<template>
  <div class="radius-dropdown">
    <select :value="selected" @input="onChange">
      <option disabled>
        {{ Dropdown }}
      </option>
      <option
        v-for="Dropdown in option"
        v-bind:value="Dropdown.name"
        v-bind:key="Dropdown.id"
      >
        {{ Dropdown.name }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "DropDown",
  props: {
    Dropdown: {
      type: String,
      default: "業種",
    },
  },
  methods: {
    onChange: function (e) {
      if (e.target.value == this.Dropdown) {
        //退会理由のままの状態だった場合”なし”
        this.$parent.selected = "なし";
      } else {
        this.$parent.selected = e.target.value;
      }
    },
  },
  data() {
    return {
      selected: this.Dropdown,
      option: [
        { id: 1, name: "自治体" },
        { id: 2, name: "人材サービス業" },
        { id: 3, name: "教育・学習支援業" },
        { id: 4, name: "製造業" },
        { id: 5, name: "建設業" },
        { id: 6, name: "仕業・コンサル業" },
        { id: 7, name: "宿泊業・飲食サービス業" },
        { id: 8, name: "卸売業・小売業" },
        { id: 9, name: "医療・福祉" },
        { id: 10, name: "不動産業・物品賃貸業" },
        { id: 11, name: "金融業・保険業" },
        { id: 12, name: "情報通信業" },
        { id: 13, name: "生活関連サービス業・娯楽業" },
        { id: 14, name: "運輸業・郵便業" },
        { id: 15, name: "その他" },
      ],
    };
  },
};
</script>

<style lang="css" scoped>
/* @import "../../css/styles.css"; */
/* @import "https://stackpath.bootstrapcdn.com/bootstrap/3.3.4/css/bootstrap.min.css"; */
/* div {
  width: 100px;
} */
.radius-dropdown {
  overflow: hidden;
  width: 68%;
  margin: auto;
  /* margin-top: 70px; */
  margin-bottom: 20px;
  border-radius: 10px;
  padding: 14px 30px;
  color: #f5f4e8;
  background-color: #696773;
}
select {
  border: none;
  background: none;
  color: #f5f4e8;
}
option {
  color: #111111;
  /* background: #f5f4e8; */
}
</style>
